import React from "react";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import AllOrderTable from "../AllOrderTable/AllOrderTable";
import { useEffect } from "react";
import { useState } from "react";
import {
  getAllOrderApi,
  getAllOrderByLimitApi,
} from "../../../Api/PanelAdminServices";
import { Modal } from "react-bootstrap";
import UserInfo from "../../Modal/Information/UserInfo/UserInfo";
import OrderListAll from "../../Modal/Information/OrderListAll/OrderListAll";
import PayingToWho from "../../Modal/Information/PayingToWho/PayingToWho";
import DeliveryInfo from "../../Modal/Information/DeliveryInfo/DeliveryInfo";
import NewFactor from "../../Modal/Information/NewFactor/NewFactor";
import { errorToast } from "../../../Utils/Toast/Toast";
import { calculateOrderTotals } from "../../../Utils/Helper/Helper";
import CancleOrder from "../../Modal/Information/CancleOrder/CancleOrder";
import Style from "./AllOrderContainer.module.scss";
const AllOrderContainer = () => {
  const [orders, setOrders] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("1");
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState([]);
  const [ModalShowState, setModalShowState] = useState({
    modalDeliver: false,
    payingModal: false,
    newFactorModal: false,
    isOrderVisible: false,
    isModalVisible: false,
    cacncelModal: false,
  });
  useEffect(() => {
    getAcceptedSupplier(selectedPeriod);
  }, []);

  const getAcceptedSupplier = (period) => {
    setLoading(true);
    const callback = (succ, res) => {
      try {
        if (succ) {
          if (res.status === 0) {
            errorToast("مشکلی پیش آمده است");
          } else {
            setOrders(res.orders || []);
          }
        } else {
          errorToast("خطایی در سرور رخ داده است");
        }
      } finally {
        setLoading(false);
      }
    };

    if (period === "all") {
      getAllOrderApi("all", callback);
    } else {
      getAllOrderByLimitApi(Number(period), callback);
    }
  };
  const handlePeriodChange = (e) => {
    const period = e.target.value;
    console.log(period);
    setSelectedPeriod(period);
    getAcceptedSupplier(period);
  };
  const showModal = async (id, info) => {
    setOrderDetail(info);
    switch (id) {
      case 1:
        setModalShowState((prevState) => ({
          ...prevState,
          isModalVisible: true,
        }));
        break;
      case 2:
        //////// order List ////////
        setModalShowState((prevState) => ({
          ...prevState,
          isOrderVisible: true,
        }));
        break;
      case 3:
        //////// pay to who ////////
        setModalShowState((prevState) => ({
          ...prevState,
          payingModal: true,
        }));
        break;
      case 4:
        //////// peyk info ////////
        setModalShowState((prevState) => ({
          ...prevState,
          modalDeliver: true,
        }));
        break;
      case 5:
        //////// new factor ////////
        setModalShowState((prevState) => ({
          ...prevState,
          newFactorModal: true,
        }));
        break;
      case 6:
        //////// cancel order ////////
        setModalShowState((prevState) => ({
          ...prevState,
          cacncelModal: true,
        }));
        break;

      default:
        break;
    }
  };

  const handleOk = () => {
    setModalShowState({
      modalDeliver: false,
      payingModal: false,
      newFactorModal: false,
      isOrderVisible: false,
      isModalVisible: false,
      cacncelModal: false,
    });
  };

  const dataList = orders.map((element) => {
    return calculateOrderTotals(element);
  });

  const data =
    dataList &&
    dataList.map((item, index) => {
      return {
        ...item,
        key: index,
        person: item.first_name + " " + item.last_name,
        orderNumber: item.id,
      };
    });
  data.sort((a, b) => b.orderNumber - a.orderNumber);
  /////// style /////////
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
    fontSize: "1.1rem",
    fontFamilly: "iran-sans",
  };
  return (
    <div>
      <Modal show={ModalShowState.isModalVisible} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات مشتری</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UserInfo Info={orderDetail} showAddress={true} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={ModalShowState.isOrderVisible} onHide={handleOk} size="xl">
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            لیست سفارش به شماره {orderDetail?.id}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OrderListAll
            Info={orderDetail}
            item={orderDetail}
            handleOk={handleOk}
          />
        </Modal.Body>
      </Modal>

      <Modal show={ModalShowState.newFactorModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>فاکتور جدید</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewFactor info={orderDetail} />
        </Modal.Body>
      </Modal>

      <Modal show={ModalShowState.modalDeliver} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات پیک</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeliveryInfo Info={orderDetail.deliver} handleOk={handleOk} />
        </Modal.Body>
      </Modal>

      <Modal show={ModalShowState.payingModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>تراکنشات کیف پول</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PayingToWho data={orderDetail} handleOk={handleOk} />
        </Modal.Body>
      </Modal>
      <Modal show={ModalShowState.cacncelModal} onHide={handleOk}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>کنسل کردن سفارش</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CancleOrder rawInfo={orderDetail} />
        </Modal.Body>
      </Modal>
      <TableFixedPage title={" همه سفارشات "} />
      <div className={Style.filterContainer}>
        <label htmlFor="orderPeriod" className={Style.filterLabel}>
          بازه زمانی:
        </label>

        <select
          id="orderPeriod"
          className={Style.filterSelect}
          value={selectedPeriod}
          onChange={handlePeriodChange}
          defaultValue={"1"}
        >
          <option value="1">۲۴ ساعت گذشته</option>
          <option value="7">هفته اخیر</option>
          <option value="30">ماه اخیر</option>
          <option value="all">کل سفارشات</option>
        </select>
      </div>

      <div className={Style.tableContainer}>
        {loading ? (
          <div className={Style.loadingContainer}>
            <div className={Style.spinner}></div>
            <span>در حال دریافت سفارشات...</span>
          </div>
        ) : (
          <AllOrderTable showModal={showModal} data={data} />
        )}
      </div>
    </div>
  );
};

export default AllOrderContainer;
